export const alertsMock = {
  notifications: [
    '<div class="userMessage userMessageWarning">' +
      ' <span class="message">Your profile is incomplete, ' +
      '<a href="/awin/merchant/1204/profile">you can complete it here.</a> ' +
      'A complete profile ensures you appear in the Advertiser Directory.</span>' +
      '<span class="remindableClose" data-usermessage-remindable-key="profileIncomplete1204"></span> ' +
      '</div>',

    '<div class="userMessage userMessageInfo"> <span class="message">' +
      `It looks like you haven't made an offer on any Publisher opportunities lately. ` +
      'There are thousands of unique Publisher Opportunities live in the Opportunity Marketplace' +
      ' from last-minute slots in publisher newsletters to display ads or sponsored content - ' +
      '<a href="/awin/merchant/1402/opportunity&#45;market&#45;directory" target="_blank">' +
      'View them here.</a></span><span class="remindableClose" ' +
      'data-usermessage-remindable-key="opportunityOfferReminder1402"' +
      ' data-usermessage-remindable-duration="2592000"></span> </div>',
  ],
};
